<script setup lang="ts">
import { components } from '~/slices'

const { client } = usePrismic()
const route = useRoute()
const { data: service } = await useAsyncData(
  `service-${route.params.uid}`,
  () => client.getByUID('service', route.params.uid as string),
)

useDocumentSeo(service)
</script>

<template>
  <main>
    <SliceZone :slices="service?.data.slices ?? []" :components="components" />
  </main>
</template>
